import { AuthModule } from './features/auth/auth.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule } from './layout/layout.module';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [

  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module')
        .then(m => m.AuthModule)
  },

  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

  {
    path: 'app',
    component: MainLayoutComponent,
    children: [
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'masters', loadChildren: () => import('./features/masters-module/masters-module.module').then(m => m.MastersModuleModule) },
      { path: 'users', loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule) }
    ]
  },

  { path: '**', redirectTo: 'auth/login' }

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
